<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div
            class="col-lg-9 com-md-6 col-sm-12 d-flex justify-content-start"
          ></div>
          <div class="col-lg-3 com-md-6 col-sm-12 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              class="mr-2"
            />
            <ts-button
              outline
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td class="ts-whitespace-no-wrap">{{ record.branch_name_en }}</td>
          <td class="ts-whitespace-no-wrap">{{ record.location_name }}</td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="'Edit'"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              v-tooltip="'Delete'"
              class="text-danger"
              @click.prevent="destroy(record)"
              :disabled="record._deleting"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
    <a-drawer
      :title="$t('filter')"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="() => (visible = false)"
      :zIndex="1020"
      width="300px"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <a-select
              style="width: 257px"
              v-model="branch_id"
              :options="branchs"
              showSearch
              mode="multiple"
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              :maxTagCount="1"
              :maxTagTextLength="17"
              :placeholder="$t('all')"
            >
            </a-select>
          </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  props: ['fetch'],
  name: 'location-settlement-table',
  data () {
    return {
      loading: false,
      visible: false,
      branchs: []
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('locationSettlement', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.locationSettlement.search
      },
      set (newValue) {
        this.$store.commit('locationSettlement/SET_SEARCH', newValue)
        this.$store.commit('locationSettlement/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get () {
        return this.$store.state.locationSettlement.branch_id
      },
      set (newValue) {
        this.$store.commit('locationSettlement/SET_BRANCH_ID', newValue)
      }
    },
    columns () {
      return [
        { name: this.$t('locationsettlement.branch') },
        { name: this.$t('locationsettlement.location') },
        {
          name: this.$t('locationsettlement.actions'),
          style: 'text-align:center; width:7%'
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'locationSettlement/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch () {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    edit (record) {
      this.$store.commit('locationSettlement/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'location-settlement-edit',
        params: { id: record.loc_set_id }
      })
    },

    async destroy (record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('locationSettlement/destroy', record.loc_set_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500),

    fetch: function () {
      this.fetchData()
      this.$emit('fetched')
    }
  }
}
</script>
